class ArticleEventInfo extends HTMLElement {
  connectedCallback() {
    this.startUTCDate = this.getAttribute('data-utc-start-timestamp');
    this.endUTCDate = this.getAttribute('data-utc-end-timestamp');
    this.targetElement = this.querySelector('[data-event-datetime-display]');
    if (!this.startUTCDate || !this.targetElement) return;
    this.formatAndDisplay();
  }

  formatAndDisplay() {
    const startDate = new Date(this.startUTCDate);
    const dateString = startDate.toLocaleDateString('en-GB', {
      timeZone: 'Europe/Amsterdam',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
    const startTime = this.formatTime(startDate);

    let output = `${dateString}, ${startTime}`;

    if (this.endUTCDate) {
      const endDate = new Date(this.endUTCDate);
      const endTime = this.formatTime(endDate);
      output += ` - ${endTime}`;
    }

    this.targetElement.textContent = output;
  }

  formatTime(date) {
    return date.toLocaleTimeString('en-GB', {
      timeZone: 'Europe/Amsterdam',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  }
}

customElements.define('article-event-info', ArticleEventInfo);
